import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 20,
  },
  products: {
    type: 'panel',
    header: {
      title: _TL_('Products'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onProductsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      storeInfo: {
        type: 'store-info',
        dynamicProps: props => props.storeInfo,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      listingGroup: {
        type: 'listing-group',
        dynamicProps: props => props.listingGroup,
      },
    },
    dynamicProps: props => props.productsPanel,
  },
  assets: {
    type: 'panel',
    header: {
      title: _TL_('Assets'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onAssetsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      assetGroupName: buildDefaultDataProperty({
        label: _TL_('Asset group name'),
        dynamicProps: props => props.assetGroupName,
      }),
      hd3: {
        type: 'horizontal-divider',
      },
      images: {
        type: 'images',
        dynamicProps: props => props.images,
      },
      videos: {
        type: 'videos',
        dynamicProps: props => props.videos,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      logos: {
        type: 'images',
        dynamicProps: props => props.logos,
      },
      hd2: {
        type: 'horizontal-divider',
      },
      headlines: {
        type: 'headlines',
        dynamicProps: props => props.headlines,
      },
      longHeadlines: {
        type: 'long-headlines',
        dynamicProps: props => props.longHeadlines,
      },
      descriptions: {
        type: 'descriptions',
        dynamicProps: props => props.descriptions,
      },
      hd4: {
        type: 'horizontal-divider',
      },
      businessName: buildDefaultDataProperty({
        label: _TL_('Business name'),
        dynamicProps: props => props.businessName,
      }),
      callToAction: buildDefaultDataProperty({
        label: _TL_('Call to action'),
        dynamicProps: props => props.callToAction,
      }),
      hd5: {
        type: 'horizontal-divider',
      },
      urlRules: {
        type: 'url-rules',
        dynamicProps: props => props.urlRules,
      },
    },
  },
  targeting: {
    type: 'panel',
    header: {
      title: _TL_('Targeting'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onTargetingHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      languages: {
        type: 'languages',
        dynamicProps: props => props.languages,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      audienceSignal: {
        type: 'audience-signal',
        dynamicProps: props => props.audienceSignal,
      },
      searchThemes: {
        type: 'search-themes',
        dynamicProps: props => props.searchThemes,
      },
    },
  },
  campaignSettings: {
    type: 'panel',
    header: {
      title: _TL_('Campaign settings'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onCampaignSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      campaignName: buildDefaultDataProperty({
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      adScheduleCampaign: {
        type: 'ad-schedule',
        dynamicProps: props => props.adScheduleCampaign,
      },
      conversionGoals: {
        type: 'conversion-goals',
        dynamicProps: props => props.conversionGoals,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      finalUrlExpansions: {
        type: 'final-url-expansions',
        dynamicProps: props => props.finalUrlExpansions,
      },
      autoGeneratedAssets: {
        type: 'auto-generated-assets',
        dynamicProps: props => props.autoGeneratedAssets,
      },
      urlOptions: {
        type: 'url-options',
        dynamicProps: props => props.urlOptions,
      },
      disclaimer: {
        type: 'disclaimer',
        dynamicProps: props => props.disclaimer,
      },
    },
  },
  budget: {
    type: 'panel',
    header: {
      title: _TL_('Budget'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onBudgetSettingsHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      bidTarget: {
        type: 'bid-target',
        dynamicProps: props => props.bidTarget,
      },
      costPerSale: {
        type: 'cost-per-sale',
        dynamicProps: props => props.costPerSale,
      },
      newCustomerAcquisition: {
        type: 'new-customer-acquisition',
        dynamicProps: props => props.newCustomerAcquisition,
      },
    },
  },
});
